// Copied from advisor-3.0/src/components/Layout/Layout.js
// Changes: children → Outlet (React Router v7), TS types
import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Nav from './Nav';
import Footer from 'src/components/Footer/Footer';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem } from 'src/utility/sessionStorage';
import 'src/styles/App.scss';
import './Layout.scss';

interface LayoutProps {
  isSignWithoutAuth?: boolean;
}

export default function Layout({ isSignWithoutAuth: isSignWithoutAuthProp }: LayoutProps) {
  // Mirror advisor-3.0/src/App.js: isSignWithoutAuth is true only when there is no
  // authenticated advisor. If an advisor is in sessionStorage (e.g. an FA opened a
  // signing link in the same tab), render the full layout with Sidebar.
  const hasAdvisorSession = Boolean(getSessionStorageItem(ADVISOR_OBJECT_KEY));
  const isSignWithoutAuth = isSignWithoutAuthProp && !hasAdvisorSession;

  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 960 || isSignWithoutAuth) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [isSignWithoutAuth]);

  if (isSignWithoutAuth) {
    return (
      <div>
        <Nav expanded={expanded} isSignWithoutAuth />
        <div id="advisor-dashboard-container" className="container">
          <Outlet />
        </div>
        <Footer expanded={expanded} isSignWithoutAuth />
      </div>
    );
  }

  return (
    <div>
      <Nav expanded={expanded} />
      <Sidebar expanded={expanded} setExpanded={setExpanded} />
      <div id="advisor-dashboard-container" className={`advisor-container ${expanded ? 'sidebar-open' : 'sidebar-close closed'}`}>
        <Outlet />
      </div>
      <Footer expanded={expanded} />
    </div>
  );
}
